import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../services/api/auth/auth.service";
import {MatIcon} from "@angular/material/icon";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-head',
  standalone: true,
  imports: [
    MatIcon,
    NgForOf
  ],
  templateUrl: './head.component.html',
  styleUrl: './head.component.css'
})
export class HeadComponent {
  constructor(private router: Router,
              private authService: AuthService) {
  }

  navigationItems = [
    {title: 'Facture', route: 'invoice', display: true},
    {title: 'Historique', route: 'transactions', display: true},
    {title: 'Stock', route: 'stocks', display: true},
    {title: 'Articles', route: 'items', display: true},
    {title: 'Accueil', route: '/', display: true},
  ]

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  navigateToPage(idx: number) {
    return this.router.navigate([this.navigationItems[idx].route]);
  }
}
